import script from "./PlayerEventView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlayerEventView.vue?vue&type=script&lang=ts&setup=true"

import "./PlayerEventView.vue?vue&type=style&index=0&id=b4dc20e6&lang=scss"

const __exports__ = script;

export default __exports__